import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-image-slider',
  templateUrl: './image-slider.component.html',
  styleUrls: ['./image-slider.component.scss']
})

export class ImageSliderComponent implements OnInit {

  @Input() attachments: any[] = [];

  @Input() autoplayInterval: number = null;
  @Input() numVisible: number = 1;
  @Input() numScroll: number = 1;
  @Input() circular: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }


  download(url) {
    window.open(url, '_blank');
  }


}
